import { createApp } from "vue";
import App from "./App.vue";
// import router from "./router/index";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import './assets/main.css'
import i18n from "./i18n.ts";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs"; // 中文
import { router, initDynamicRoutes } from './router'
import permission from "@/directive/permission.ts";

import comButton from "@/components/comButton/index.vue";
import comDialog from "@/components/comDialog/index.vue";
import comForm from "@/components/comForm/index.vue";
import comList from "@/components/comList/index.vue";
import comTable from "@/components/comTable/index.vue";
import comCueBox from "@/components/comCue/comCue";
import agTable from "@/components/agTable/index.vue";

// 全局兼容 replaceAll（支持旧版浏览器/企业微信）
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (match, rep) {
    return this.replace(new RegExp(match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), rep);
  };
}

(async () => {
  // ① 先拉动态路由并注入
  await initDynamicRoutes()
const app = createApp(App);
app.use(i18n);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}


app.component("ComButton", comButton);
app.component("ComDialog", comDialog);
app.component("ComForm", comForm);
app.component("ComList", comList);
app.component("ComTable", comTable);
app.component("ComCueBox", comCueBox);
app.component("AgTable", agTable);

// 注册自定义指令
app.directive('permission', permission);

app.mount("#app");
})()
